/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RoleDeletionImpactResponseDto
 */
export interface RoleDeletionImpactResponseDto {
    /**
     * 
     * @type {string}
     * @memberof RoleDeletionImpactResponseDto
     */
    roleId: string;
    /**
     * 
     * @type {string}
     * @memberof RoleDeletionImpactResponseDto
     */
    roleName: string;
    /**
     * 
     * @type {number}
     * @memberof RoleDeletionImpactResponseDto
     */
    usersCount: number;
}

/**
 * Check if a given object implements the RoleDeletionImpactResponseDto interface.
 */
export function instanceOfRoleDeletionImpactResponseDto(value: object): value is RoleDeletionImpactResponseDto {
    if (!('roleId' in value) || value['roleId'] === undefined) return false;
    if (!('roleName' in value) || value['roleName'] === undefined) return false;
    if (!('usersCount' in value) || value['usersCount'] === undefined) return false;
    return true;
}

export function RoleDeletionImpactResponseDtoFromJSON(json: any): RoleDeletionImpactResponseDto {
    return RoleDeletionImpactResponseDtoFromJSONTyped(json, false);
}

export function RoleDeletionImpactResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleDeletionImpactResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'roleId': json['roleId'],
        'roleName': json['roleName'],
        'usersCount': json['usersCount'],
    };
}

export function RoleDeletionImpactResponseDtoToJSON(json: any): RoleDeletionImpactResponseDto {
    return RoleDeletionImpactResponseDtoToJSONTyped(json, false);
}

export function RoleDeletionImpactResponseDtoToJSONTyped(value?: RoleDeletionImpactResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'roleId': value['roleId'],
        'roleName': value['roleName'],
        'usersCount': value['usersCount'],
    };
}

